<div class="errorLogo">
  <img src="../assets/images/logo/logo-white.svg" alt="Indy Chamber logo" class="logo">
</div>
<div class="errorCity">
  <img src="../assets/images/cute-city.svg" alt="error background" class="cuteCity">
</div>

<div class="errorDiv">
  <div>
    <h2>Oops!</h2>
  </div>
  <div>
    <p>
      The page you are looking for could not be found.
    </p>
  </div>
  <div>
    <button *ngIf="contactType == 'SuperAdmin'" [routerLink]="['/admin-portal/chamber/super-admin-member-management']" type="button" class="btn btn-lg btn-block error-btn">Return Home</button>
    <button *ngIf="contactType == 'BusinessUser'" [routerLink]="['/admin-portal/member/user-management']" type="button" class="btn btn-lg btn-block error-btn">Return Home</button>
  </div>
</div>
